import { Box, Button, Paper } from '@mui/material';
import {
  add,
  differenceInDays,
  getDay,
  getMonth,
  getYear,
  set,
} from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { useQuery } from 'react-query';
import {
  Area,
  Bar,
  CartesianGrid,
  ComposedChart,
  Label,
  Legend,
  Line,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { useRecoilValue } from 'recoil';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';
import { getDayOfWeek, getMonthText, getTypeWord } from '../../common/helper';
import NoDataPage from '../commonComponent/NoDataPage';
import { SwTitleDownloadMore } from '../commonComponent/SwTitleDownloadMore';
import { SwRwwTab } from '../commonComponent/SwRwwTab';
import { RwwCumulativeGraphByGender } from './RwwCumulativeGraphByGender';
import {
  KEY_CUMULATIVE,
  KEY_READ_TEXT,
  KEY_SCHOOL_MONTHLY_MEMBER_LIST,
  KEY_SCHOOL_MONTHLY_READ_STAT_LIST,
  KEY_SCHOOL_MONTHLY_WALK_STAT_LIST,
  KEY_SCHOOL_MONTHLY_WRITE_STAT_LIST,
  KEY_WALK_TEXT,
  KEY_WRITE_TEXT,
} from '../../common/key';

import { getClassMonthlyReadRankList } from '../../common/api/ApiClassStat';
import {
  downloadSchoolMonthlyDataList,
  downloadSchoolMonthlyMemberData,
  getSchoolMonthlyMemberList,
  getSchoolMonthlyReadStatList,
  getSchoolMonthlyWalkStatList,
  getSchoolMonthlyWriteStatList,
} from '../../common/api/ApiSchool';
import { selectSchoolInfoState } from '../../common/atom';
import { RwwMemberGraphByGender } from './RwwMemberGraphByGender';

interface Props {
  startDate: number;
  from?: string;
  isPdf?: boolean;
}

export const RwwMemberStatistics: React.FC<Props> = ({
  startDate,
  from = 'dashboard',
  isPdf = false,
}) => {
  const schoolClassInfo = useRecoilValue(selectSchoolInfoState);
  const [reqRequest, setReqRequest] = useState<boolean>(false);
  const [requestData, setRequestData] = useState<any>();
  const [schoolSeq, setSchoolSeq] = useState<number>(0);
  const [rowCount, setRowCount] = useState<number>(1);
  const [rateData, setRateData] = useState<any>([]);
  const { width, ref } = useResizeDetector();
  const [loading, setLoading] = useState<any>(false);
  const [statType, setStatType] = useState<string>('');

  const {
    data,
    isLoading,
    refetch: refetchSchoolMonthlyMember,
  } = useQuery(
    KEY_SCHOOL_MONTHLY_MEMBER_LIST,
    () => {
      if (reqRequest) {
        const newData: any = {
          schoolSeq: schoolClassInfo.schoolSeq,
          year: getYear(startDate * 1000),
        };
        return getSchoolMonthlyMemberList(newData);
      }
      return null;
    },
    {
      onSuccess: res => {
        setLoading(false);
        if (res !== null) {
          setRequestData(res);
        } else {
          setRequestData(null);
        }
      },
      onError: e => {
        setLoading(false);
        console.log(e);
      },
    }
  );

  const downloadClassMonthlyData = () => {
    const newData: any = {
      schoolSeq: schoolClassInfo.schoolSeq,
      year: getYear(startDate * 1000),
    };
    downloadSchoolMonthlyMemberData(newData);
  };

  useEffect(() => {
    if (schoolClassInfo.schoolSeq !== 0) {
      setReqRequest(true);
      refetchSchoolMonthlyMember();
    }
  }, [schoolClassInfo]);

  useEffect(() => {
    if (schoolClassInfo.schoolSeq !== 0 && reqRequest) {
      refetchSchoolMonthlyMember();
    }
  }, [reqRequest]);

  useEffect(() => {
    if (schoolClassInfo.schoolSeq !== 0) {
      setReqRequest(true);
      refetchSchoolMonthlyMember();
    }
  }, []);

  return (
    <>
      <Paper sx={{ backgroundColor: '#fff' }}>
        <Box className='flex_between'>
          <SwTitleDownloadMore title='우리 학교 사용자 수 데이터' />
          <Button
            sx={{ ml: '1rem' }}
            color='info'
            onClick={downloadClassMonthlyData}
          >
            데이터 다운로드
            <FileDownloadRoundedIcon color='success' />
          </Button>
        </Box>
        <RwwMemberGraphByGender
          stepsGoalRateAverage={[false, false]}
          startDate={startDate}
          totalAverage={requestData?.totalRate ?? 0}
          data={requestData?.statList}
          isPdf={false}
        />
      </Paper>
    </>
  );
};
